import config from "@Config/index";
import axios from "axios";
import { filterActiveChildInventories } from "../RecentelyViewedSection/helper";

export const getInventoryBudgetFriendly = async (id: any, options: any = {}) => {
  try {
    const res: any = await axios.get(
      `${config.API_URL}/api/v0/inventories/${id}/budget_friendly`,
      options,
    );
    let budgetFriendlyData = res?.data?.data || [];
    if (budgetFriendlyData.length > 0) {
      budgetFriendlyData = filterActiveChildInventories(budgetFriendlyData);
    }
    return budgetFriendlyData;
  } catch (error) {
    if (typeof window !== "undefined" && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`BudgetFriendly API error for id ${id} -> ${error}`, {
        extra: { id, options, error },
      });
    }
    return { error };
  }
};

export const getInventoryBudgetFriendlyById = async (options: any = {}) => {
  const INVENTORY_LIMIT = 10;
  let finalData: any = [];
  const inventoryId = options?.inventory_id;
  const inventoriesOptions: any = {
    params: {
      limit: INVENTORY_LIMIT,
      use_open_search: true,
      only: "id,name,canonical_name,location,available,pricing,region_id,images,status,reviews_count,reviews_rating",
      type: "empty",
      methods: "meta_short,images_with_featured,reviews_count,reviews_rating",
    },
  };
  if (options.userCurrency) inventoriesOptions.params.user_currency = options.userCurrency;
  const response: any = await getInventoryBudgetFriendly(inventoryId, inventoriesOptions);
  if (response?.length > 0) {
    finalData = response;
  }

  return finalData;
};
